import {
  Component,
  OnInit,
  OnDestroy,
  HostListener,
  Output,
} from '@angular/core';
import { EventEmitter } from 'events';
import { Subscription } from 'rxjs';
import { User } from 'src/app/core/model/user-model';
import { SettingService } from 'src/app/data/repository/setting-repository/setting.service';
import { UserDataService } from 'src/app/data/repository/user-repository/user-data.service';
import { DateHelper } from 'src/app/utils/date-helper';
import { BottomsheetShared } from '../../general/shared/bottomsheet-shared';

@Component({
  selector: 'app-personal-info',
  templateUrl: './personal-info.component.html',
  styleUrls: ['./personal-info.component.scss'],
})
export class PersonalInfoComponent implements OnInit, OnDestroy {
  showLoading = false;

  showEdit = false;
  selectedType: string;
  user: User;

  profileTitles = ['جنسیت', 'قد', 'تاریخ تولد', 'شماره تلفن'];
  profileValues = ['', '', '', ''];

  subscription1: Subscription;
  subscription2: Subscription;

  constructor(
    private settingService: SettingService,
    private userDataService: UserDataService,
    private dateHelper: DateHelper,
    private bottomsheetShared: BottomsheetShared
  ) {
    this.subscription1 = this.bottomsheetShared.closeBottomsheetObs$.subscribe(
      (close) => {
        if (close) {
          this.showEdit = false;
          this.settingService.closeBottomSheet.next({ show: false });
        }
      }
    );

    this.subscription2 =
      this.bottomsheetShared.closeAndUpdateBottomsheetObs$.subscribe(
        (close) => {
          if (close) {
            this.prepare();
            this.showEdit = false;
            this.settingService.closeBottomSheet.next({ show: false });
          }
        }
      );

    this.prepare();
  }

  ngOnInit() {}

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
  }

  back() {
    this.settingService.goBack();
  }

  prepare() {
    this.showLoading = true;
    this.userDataService.getUser().then((result) => {
      if (result) {
        this.user = result;
        this.profileValues[0] = result.sex === 'male' ? 'آقا' : 'خانم';
        this.profileValues[1] = result.height.toString() + ' سانتی‌ متر';
        this.profileValues[2] = this.dateHelper.getPersianBirthdayFormat(
          new Date(result.birthDate)
        );
        if (result.email) {
          this.profileValues[3] = result.email;
          this.profileTitles[3] = 'ایمیل';
          console.log(result.email);
        } else {
          this.profileValues[3] = result.username;
        }
      }
      this.showLoading = false;
    });
  }

  openEdit(index: number) {
    switch (index) {
      case 0:
        this.selectedType = 'gender';
        break;
      case 1:
        this.selectedType = 'height';
        break;
      case 2:
        this.selectedType = 'birthdate';
        break;
      case 3:
        this.selectedType = 'credentials';
        break;
    }
    this.showEdit = true;
    this.settingService.bottomSheet.next({
      show: this.showEdit,
      data: {
        selected: this.selectedType,
        user: this.user,
      },
    });
  }
}
